import { IUserState } from './user-states.store'
import { MutationTree } from 'vuex';
import _set from 'lodash/set';
import { default as StoreTypes } from '../types';
import { UserListingModel, IUserListingModel } from '../../models/user';
import UserStoreTypes from './user-types.store';
import { IPagination } from '../../models/app-configuration';
import { IAuthConfigModel } from '../../models/user/auth-config.model';
import { IUserconfiguration, IAccountConfiguration, AccountConfiguration, ITwoFactorAuth, TwoFactorAuth, NotificationConfig, INotificationConfig } from '../../models/user-configuration/user-configuration';
import Vue from "vue";


const mutations: MutationTree<IUserState> = <MutationTree<IUserState>>{
    [StoreTypes.Set.LOADING]:
        (state: IUserState, data) => {
            state[data.type] = data.value;
        },
    [StoreTypes.Set.PAGINATION]:
        (state: IUserState, pagination: IPagination) => {
            state.pagination = pagination;
        },
    [UserStoreTypes.Set.LIST_OF_USERS]:
        (state: IUserState, listOfManagers: UserListingModel[]) => {
            if (listOfManagers && listOfManagers[0] && listOfManagers[0].Name) {
                state.listOfUsers = listOfManagers.sort(function (a, b) {
                    if (!a || !b) {
                        return 0;
                    }
                    let nameA = a.Name ? a.Name.toUpperCase() : (a.Id ? a.Id.toString() : '');
                    let nameB = b.Name ? b.Name.toUpperCase() : (b.Id ? b.Id.toString() : '');
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                })
            } else {
                state.listOfUsers = listOfManagers;
            }
        }
    , [UserStoreTypes.Set.LIST_OF_USERS_BY_IDNAME]:
        (state: IUserState, listOfUsers: IUserListingModel[]) => {
            if (listOfUsers && listOfUsers[0] && listOfUsers[0].Name) {
                state.listOfUsers = listOfUsers.sort(function (a, b) {
                    if (!a || !b) {
                        return 0;
                    }
                    
                    let nameA = a.Name ? a.Name.toUpperCase() : (a.Id ? a.Id.toString() : '');
                    let nameB = b.Name ? b.Name.toUpperCase() : (b.Id ? b.Id.toString() : '');
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                })
            } else {
                state.listOfUsers = listOfUsers;
            }
        }
    , [UserStoreTypes.Set.AUTH_CONFIG]:
        (state: IUserState, config: IAuthConfigModel) => {
            if (config.SiteInfo) {
                window.document.title = config.SiteInfo.CompanyName || config.SiteInfo.SiteName
            }
            state.authConfig = config;
        },
    [UserStoreTypes.Set.UPDATE_USER_CONFIG]: (state, payload: { keyChain: string, value: any }) => {
        _set(state.authConfig, payload.keyChain, payload.value);
    },

    // API NEW
    [UserStoreTypes.Set.USER_INFO]: (state, payload: IUserconfiguration) => {
        state.userInfo = payload;
        state.userInfo.TempAvatar = payload.AvatarUrl;
    },
    [UserStoreTypes.Set.USER_INFO_ASSIGN_VALUE]: (state, payload: { key: string, value: any }) => {
        Vue.set(state.userInfo, payload.key, payload.value);
    },
    [UserStoreTypes.Set.USER_INFO_ORIGINAL]: (state, payload: IUserconfiguration) => {
        state.userInfoOriginal = payload
        state.userInfoOriginal.TempAvatar = payload.AvatarUrl;
    },

    [UserStoreTypes.Set.USER_CONFIGURATION]: (state, payload: IAccountConfiguration) => {
        state.accountConfiguration = new AccountConfiguration(payload);
    },
    [UserStoreTypes.Set.USER_RIGHTS]: (state, payload: IAccountConfiguration) => {
        state.userRights = payload;
    },
    [UserStoreTypes.Set.USER_CONFIGURATION_ORIGINAL]: (state, payload: IAccountConfiguration) => {
        state.accountConfigurationOriginal = new AccountConfiguration(payload);
    },
    [UserStoreTypes.Set.USER_CONFIGURATION_OUTLOOK_SYNC_ASSIGN_VALUE]: (state, payload: { key: string, value: any }) => { 
        Vue.set(state.accountConfiguration.OutlookSync, payload.key, payload.value);
    },
    [UserStoreTypes.Set.USER_CONFIGURATION_SYNC_PERSON_INFO_ASSIGN_VALUE]: (state, payload: { key: string, value: any }) => {
        Vue.set(state.accountConfiguration.SyncPersonsInfo, payload.key, payload.value);
    },
    [UserStoreTypes.Set.USER_CONFIGURATION_TASK_AGENDA_ASSIGN_VALUE]: (state, payload: { key: string, value: any }) => {
        Vue.set(state.accountConfiguration.TasksInAgenda, payload.key, payload.value);
    },
    [UserStoreTypes.Set.USER_CONFIGURATION_AGENDA_ASSIGN_VALUE]: (state, payload: { key: string, value: any }) => {
        Vue.set(state.accountConfiguration.Agenda, payload.key, payload.value);
    },
    [UserStoreTypes.Set.USER_CONFIGURATION_EXCHANGE_CONFIG_ASSIGN_VALUE]: (state, payload: { key: string, value: any }) => {
        Vue.set(state.accountConfiguration.ExchangeConfig, payload.key, payload.value);
    },

    [UserStoreTypes.Set.TWO_FACTOR]: (state, payload: ITwoFactorAuth) => {
        state.twoFactorAuthenticate = new TwoFactorAuth(payload);
    },
    [UserStoreTypes.Set.TWO_FACTOR_ORIGINAL]: (state, payload: ITwoFactorAuth) => {
        state.twoFactorAuthenticateOriginal = new TwoFactorAuth(payload);
    },
    [UserStoreTypes.Set.TWO_FACTOR_ASSIGN_VALUE]: (state, payload: { key: string, value: any }) => {
        Vue.set(state.twoFactorAuthenticate, payload.key, payload.value);
    },
    
    [UserStoreTypes.Set.NOTIFICATION_CONFIG]: (state, payload: INotificationConfig) => {
        state.notificationConfig = new NotificationConfig(payload);
    },
    [UserStoreTypes.Set.NOTIFICATION_CONFIG_ORIGINAL]: (state, payload: INotificationConfig) => {
        state.notificationConfigOriginal = new NotificationConfig(payload);
    },
    [UserStoreTypes.Set.NOTIFICATION_CONFIG_APPOINTMENT]: (state, payload: { key: string, value: any }) => {
        Vue.set(state.notificationConfig.Appointment, payload.key, payload.value);
    },
    [UserStoreTypes.Set.NOTIFICATION_CONFIG_TASK]: (state, payload: { key: string, value: any }) => {
        Vue.set(state.notificationConfig.Task, payload.key, payload.value);
    },
    [UserStoreTypes.Set.NOTIFICATION_CONFIG_OTHER]: (state, payload: { key: string, value: any }) => {
        Vue.set(state.notificationConfig.Others, payload.key, payload.value);
    },
}

export default mutations;